<template>
  <div class="home">
    <!-- 头部 -->
    <commonHeader :isactive="1"></commonHeader>
    <!-- 轮播 -->
    <homeSwiper></homeSwiper>
    <!-- 我们能坐什么 -->
    <homeThree></homeThree>
    <!-- 为什么选择我们 -->
    <selectAdvantage></selectAdvantage>
    <!-- 严控流程 -->
    <flowpath></flowpath>
    <!-- 精品项目案例 -->
    <bottomSwiper></bottomSwiper>
    <!-- 底部 -->
    <commonBottom></commonBottom>
    <!-- 返回顶部 -->
    <backTop></backTop>
  </div>
</template>

<script>
import commonHeader from '@/components/common/commonHeader.vue'
import homeSwiper from '@/components/home/homeSwiper.vue'
import homeThree from '@/components/home/homeThree.vue'
import selectAdvantage from '@/components/home/selectAdvantage.vue'
import flowpath from '@/components/home/flowPaths.vue'
import bottomSwiper from '@/components/home/bottomSwiper.vue'
import commonBottom from '@/components/common/commonBottom.vue'
import backTop from '@/components/common/backTop.vue'
export default {
  name: 'HomeView',
  components: {
    commonHeader,
    homeSwiper,
    homeThree,
    selectAdvantage,
    flowpath,
    bottomSwiper,
    commonBottom,
    backTop
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
}
</style>
